// extracted by mini-css-extract-plugin
module.exports = {"AddMoreWrapper":"NewTaskCard_AddMoreWrapper__1H5Zw","InputBox":"NewTaskCard_InputBox__1LiPY","ButtonWrapper":"NewTaskCard_ButtonWrapper__hQfoT"};